import React from "react"
import { graphql } from "gatsby"
import pk from "../images/pk.png"
import yhsg from "../images/yhsg.jpg"
import Img from "gatsby-image"
import HeaderMenu from "../components/header_menu"
import { withPrefix } from "gatsby"
import { Helmet } from "react-helmet"



export default class BlogList extends React.Component {
	
  render() {
    const posts = this.props.data.list.edges
    const recentPosts = this.props.data.recent.edges
    const { currentPage, numPages } = this.props.pageContext
    const isFirst = currentPage === 1
    const isLast = currentPage === numPages
    const prevPage = currentPage - 1 === 1 ? withPrefix("/blog/") : withPrefix("/blog/")+(currentPage - 1).toString() + "/"
    const nextPage = withPrefix("/blog/") + (currentPage + 1).toString() + "/"

    const style1 = {position: "relative"};
    const style2 = {backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover"};
    const style3 = {display: "table-cell", width: "70%", verticalAlign: "bottom"};
    const style4 = {marginTop: "50px"};
    const style5 = {textAlign: "center", display: "table-cell", verticalAlign: "bottom", paddingRight: "5px"};
    const style6 = {color: "white", fontFamily: "futura-pt, sans-serif", textShadow: "0 5px 5px rgba(0,0,0,1)"};
    const style7 = {color: "white", textShadow: "0 5px 5px rgba(0,0,0,1)"};
    const style8 = {color: "red", fontWeight: "bold", fontSize: "large"};
    const style9 = {backgroundColor: "white"};
    const style10 = {fontSize: "larger", textAlign: "center", fontWeight: "bold", paddingBottom: "10px"};
    const style11 = {marginTop: "20px"};
	const style12 = {padding: "6px 12px", borderRadius: "4px", backgroundColor: "royalblue", color: "white"};
	const style13 = {color: "red"};
	const style14 = {paddingBottom: "0px", margin: "0px"};
  const style15 = {fontSize: "16px"};
	const trackingCode = `<script>
							(function(w,d,t,u,n,a,m){w['MauticTrackingObject']=n;
							w[n]=w[n]||function(){(w[n].q=w[n].q||[]).push(arguments)},a=d.createElement(t),
							m=d.getElementsByTagName(t)[0];a.async=1;a.src=u;m.parentNode.insertBefore(a,m)
							})(window,document,'script',mauticSrc+'/mtc.js','mt')
						</script>`

    return (

    <>
	
	<Helmet>
	  <title>Blog - WebERealty</title>
      <meta name="description" content="Your home Sold Guaranteed or I'll Buy it!" />
      <meta property="og:url" content="https://weberealty.thrivebrokers.com" />
      <meta property="og:title" content="Blog - WebERealty" />
      <meta property="og:description" content="Your home Sold Guaranteed or I'll Buy it!" />
	  <meta property="og:image" content={yhsg} />
	</Helmet> 
	
	<div id="page-wrapper" style={style1}>
        <div id="content" className="bgclr0">
		
            <HeaderMenu> </HeaderMenu>
			
            <div className="header-container" role="banner">
                <header className="wrapper clearfix bgclr8">
                    <div style={style2} className="banner">
                        <div style={style3}>
							            <img src={pk} className="pk" style={style4} />
                        </div>
                        <div style={style5}>
                            <h1 className="title" style={style6}>YOUR HOME SOLD GUARANTEED!*</h1>
                            <div className="contact" style={style7}>
                                <h3>Praveen Kumar</h3>
                                <h3><i className="fa fa-phone"></i> (925) 452-7483</h3>
                                <h3><i className="fa fa-envelope"></i> praveen@weberealty.com</h3>
                            </div>
                        </div>
                    </div>
                </header>
            </div>
            
            <div className="main-container" style={style11}>
                <div className="main wrapper clearfix bgclr6">
                    

<article className="bgclr8 grid-container" role="article" style={style14}>
      
        {posts.map(({ node }) => {
          const title = node.frontmatter.title || node.fields.slug
          let featuredImgFluid = node.frontmatter.featuredImage.childImageSharp.fluid
		  let path = withPrefix(node.frontmatter.path + "/");
          return (
		    <div className="grid-item">
				<div style={style8}> <a style={style13} href={path}> {node.frontmatter.description} </a> </div>
				<div> <a href={path}> {node.frontmatter.date} </a> </div>
				<a href={path}> <Img fluid={featuredImgFluid} /> </a>
				<br></br>
				<a style={style12} href={path}>Read More</a>
            </div>
          )
        })}
		<br></br>
        <ul
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'center',
            listStyle: 'none',
            padding: 0,
          }}
        >
          {!isFirst && (
            <a href={prevPage} rel="prev">
              ← Previous Page
            </a>
          )}
          {Array.from({ length: numPages }, (_, i) => (
            <li
              key={`pagination-number${i + 1}`}
              style={{
                margin: 0,
              }}
            >
              <a
                href= {i === 0 ? withPrefix('/blog/') : withPrefix('/blog/')+(i + 1)+"/"}
                style={{
                  textDecoration: 'none',
                  color: i + 1 === currentPage ? '#ffffff' : '',
                  background: i + 1 === currentPage ? '#007acc' : '',
                  padding: '5px'
                }}
              >
                {i + 1}
              </a>
            </li>
          ))}
          {!isLast && (
            <a href={nextPage} rel="next">
              Next Page →
            </a>
          )}
        </ul>

</article>
 <aside style={style9} className="bgclr3" id="aside">

	<div style={style10}>Recent Posts</div>
        <ul>
	{recentPosts.map(({ node }) => {
		let path = withPrefix(node.frontmatter.path + "/");
          return (
		<li><a style={style15} href={path}>{node.frontmatter.description}</a></li>
                 )
        })}
        </ul>

 </aside>
    
    </div>
</div>
        
	<div className="footer-container">
		<footer className="wrapper">
		<div id="contactinfo"><div id="disclosure"><center>Information courtesy of Praveen Kumar 01928307 @ WebERealty<br/> 12935 Alcosta Blvd. #3681, San Ramon ,California, 94583<br/> praveen@weberealty.com</center></div></div>
		</footer>
	</div>
           
        </div>      
    </div>
    <div dangerouslySetInnerHTML={{ __html: trackingCode }} />
	</>
    )
  }
}



export const blogListQuery = graphql`
  query blogListQuery($skip: Int!, $limit: Int!) {
    list: allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          html
          frontmatter {
            date(formatString: "MMMM YYYY")
            title
            description
            path
            featuredImage {
          	childImageSharp {
            		fluid(maxWidth: 800) {
                	...GatsbyImageSharpFluid
            		}
          	}
            }
          }
        }
      }
    }
    recent: allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      limit: 20
    ) {
      edges {
        node {
          frontmatter {
            description
            path
          }
        }
      }
    }
  }
`
